module.exports = __webpack_public_path__ + "img/头图_2024世界人工智能大会.8b7a0410.png";